import type { SxProps, Theme } from "@mui/material/styles";
import { keyframes } from "@mui/system";

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const loadingInputSx: SxProps<Theme> = {
  "& .MuiInputBase-root": {
    position: "relative",
    background: (theme) =>
      `linear-gradient(
              90deg,
              ${theme.palette.action.hover} 25%,
              ${theme.palette.action.selected} 50%,
              ${theme.palette.action.hover} 75%
            )`,
    backgroundSize: "400% 100%",
    animation: `${shimmer} 1.6s infinite`,
    "& input": {
      position: "relative",
      backgroundColor: "transparent",
      zIndex: 1,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      zIndex: 0,
      borderRadius: 1,
    },
  },
};

export const loadingYesNoInputSx: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  borderRadius: 1,
  p: 0,
  background: (theme) =>
    `linear-gradient(
            90deg,
            ${theme.palette.action.hover} 25%,
            ${theme.palette.action.selected} 50%,
            ${theme.palette.action.hover} 75%
          )`,
  backgroundSize: "400% 100%",
  animation: `${shimmer} 1.6s infinite`,
  "& .MuiToggleButton-root": {
    zIndex: 1,
    backgroundColor: "transparent",
    color: "inherit",
    border: "none",
    "&.Mui-selected": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    zIndex: 0,
  },
};
